import { mapEnumToOptions } from '@abp/ng.core';

export enum EvaluationState {
  Pending = 0,
  InProgress = 1,
  Finished = 2,
}

export const evaluationStateOptions = mapEnumToOptions(EvaluationState);
